"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapStringFilter = mapStringFilter;
const stringFilterField = (filter) => filter.useKeywordSubfield === false ? filter.field : `${filter.field}.keyword`;
function mapStringFilter(filter) {
    const field = stringFilterField(filter);
    if (filter.operator === 'IS_NOT_IN' || filter.operator === 'IS_NOT_EQUAL_TO') {
        return {
            bool: {
                must_not: {
                    terms: {
                        [field]: Array.isArray(filter.value) ? filter.value : [filter.value],
                    },
                },
            },
        };
    }
    return {
        terms: {
            [field]: Array.isArray(filter.value) ? filter.value : [filter.value],
        },
    };
}
//# sourceMappingURL=map-string-filter.js.map